import authenticated from './http-clients/authenticated'

export default {
  index(params) {
    let url = `/tenants/${params.tenantID}/modules/${params.moduleID}/components?`

    if (typeof(params.short) !== 'undefined' && params.short !== null) {
      url = `${url}&short=${params.short}`
    }
    if (typeof(params.paginate) !== 'undefined' && params.paginate !== null) {
      url = `${url}&paginate=${params.paginate}`
    }
    if (typeof(params.active) !== 'undefined' && params.active !== null) {
      url = `${url}&active=${params.active}`
    }
    if (typeof(params.showHidden) !== 'undefined' && params.showHidden !== null) {
      url = `${url}&show-hidden=${params.showHidden}`
    }
    if (typeof(params.archived) !== 'undefined' && params.archived !== null) {
      url = `${url}&archived=${params.archived}`
    }
    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }
    if (typeof(params.search) !== 'undefined' && params.search !== null) {
      url = `${url}&search=${params.search}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    return authenticated({
      url,
      method: 'get'
    })
  },
  show({tenantID, moduleID, componentID}) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/components/${componentID}`,
      method: 'get'
    })
  },
  store({tenantID, moduleID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/components`,
      method: 'post',
      data
    })
  },
  update({tenantID, moduleID, componentID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/components/${componentID}`,
      method: 'post',
      data
    })
  },
  destroy({tenantID, moduleID, componentID}) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/components/${componentID}`,
      method: 'delete'
    })
  },
  bulkUpdate({tenantID, moduleID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/components`,
      method: 'patch',
      data
    })
  },
  hide({tenantID, moduleID, componentID}) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/components/hidden/${componentID}`,
      method: 'post'
    })
  },
  unhide({tenantID, moduleID, componentID}) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/components/hidden/${componentID}`,
      method: 'delete'
    })
  },
  copy({tenantID, moduleID, componentID}) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/components/copy/${componentID}`,
      method: 'post'
    })
  },
  move({tenantID, moduleID, componentID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/components/move/${componentID}`,
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/components.js